// extracted by mini-css-extract-plugin
export default {"layout":"layout__1m4pP"};